import {
  createContext,
  useReducer,
  useContext,
  type PropsWithChildren,
  type Dispatch,
} from 'react';

import initialState from './initial-state';
import RatesPricingReducer, { type Action } from './reducer';

import type { RatesPricingState } from './common.types';

type RatesPricingContextType = {
  state: RatesPricingState;
  dispatch: Dispatch<Action>;
};

const RatesPricingContext = createContext<RatesPricingContextType | undefined>({
  state: initialState,
  dispatch: () => {
    // do nothing.
  },
});

const { Provider } = RatesPricingContext;

const RatesPricingProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [state, dispatch] = useReducer(RatesPricingReducer, initialState);
  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

const useRatesPricingContext = () => {
  const context = useContext(RatesPricingContext);

  if (context === undefined) {
    throw new Error('Component must be used within a RatesPricingProvider');
  }

  return context;
};

export { RatesPricingContext, RatesPricingProvider, useRatesPricingContext };
